import Football from '../assets/football.png'
import netImg from '../assets/goal net.png'
import Navbar from '../Component/Navbar'
import Footer from '../Component/Footer'
import GoToHomeLink from '../Component/GoToHomeLink'

function NotFoundPage() {
  return (
    <main>
      <Navbar />
      <section className='notFoundSection'>
        <img src={netImg} alt='' className='netImg' />
        <div className='content'>
          <i className='bi bi-emoji-frown'></i>
          <h1>
            Page <span className='blueGradientTxt'>not found</span>{' '}
          </h1>
          <p className='greenGradientTxt'>
            Sorry! the current url does not exist.
          </p>
          <GoToHomeLink className='btn' />
          <img src={Football} alt='' className='footballImg' />
        </div>
      </section>
      <Footer />
    </main>
  )
}

export default NotFoundPage
